/**
 * 날짜·시간·숫자 표시 규칙을 한 곳에 모읍니다.
 * 브라우저 언어와 관계없이 한국어 표기로 고정합니다.
 */
const pad = (n: number) => String(n).padStart(2, '0');

const toDate = (value?: string | number | Date | null): Date | null => {
  if (value === undefined || value === null || value === '') return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** 2026.11.04 */
export const formatDate = (value?: string | number | Date | null, fallback = '-'): string => {
  const d = toDate(value);
  return d ? `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())}` : fallback;
};

/** 2026.11.04 21:05 */
export const formatDateTime = (value?: string | number | Date | null, fallback = '-'): string => {
  const d = toDate(value);
  return d ? `${formatDate(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}` : fallback;
};

/** 95 → "1시간 35분", 40 → "40분" */
export const formatMinutes = (minutes?: number | null, fallback = '-'): string => {
  if (minutes === undefined || minutes === null || Number.isNaN(minutes)) return fallback;
  const m = Math.max(0, Math.round(minutes));
  const h = Math.floor(m / 60);
  const rest = m % 60;
  if (h === 0) return `${rest}분`;
  return rest === 0 ? `${h}시간` : `${h}시간 ${rest}분`;
};

/** "aws-saa-c03" → "SAA-C03". 형식이 다르면 원래 값을 돌려줍니다. */
export const formatExamCode = (examTypeId?: string | null): string => {
  if (!examTypeId) return '-';
  const match = examTypeId.match(/[a-z]{3}-c\d{2}$/i);
  return match ? match[0].toUpperCase() : examTypeId;
};
